'use strict';

import EventsList from './components/events-list';

const eventHolder = new Vue({
    el: '#event-holder-page',
    components:  {
        EventsList
    },
    data() {
        return {};
    },
});
